import type {
  ScreenMethods,
  ScreenType,
  GridPosition,
  GridId,
  ScreenLayout,
} from "@observe-tech/utils";
import type { SyncStore as Store } from "../../infra/state";
import { halfScreenStrategies } from "./strategies";

export const createOverlayOperations = (
  store: Store,
  findScreenLayout: (screenId: number) => ScreenLayout,
  setScreenLayout: (screenId: number, layout: ScreenLayout) => ScreenLayout,
  positionToGridId: (position: GridPosition) => GridId,
) => {
  const getOverlays: ScreenMethods["getOverlays"] = async (screenId) => {
    const layout = findScreenLayout(screenId);

    return {
      fullScreen: layout.screenData.fullScreen,
      halfScreenLeft: layout.screenData.halfScreenLeft,
      halfScreenRight: layout.screenData.halfScreenRight,
    };
  };

  const setFullScreen: ScreenMethods["setFullScreen"] = (
    screenId,
    position,
  ) => {
    const layout = findScreenLayout(screenId);

    const gridId = positionToGridId(position);
    layout.screenData.fullScreen =
      layout.screenData.fullScreen === gridId ? null : gridId;

    setScreenLayout(screenId, layout);
  };

  const setHalfScreenLeft: ScreenMethods["setHalfScreenLeft"] = (
    screenId,
    position,
  ) => {
    const layout = findScreenLayout(screenId);

    const gridId = positionToGridId(position);
    layout.screenData.halfScreenLeft =
      layout.screenData.halfScreenLeft === gridId ? null : gridId;

    setScreenLayout(screenId, layout);
  };

  const setHalfScreenRight: ScreenMethods["setHalfScreenRight"] = (
    screenId,
    position,
  ) => {
    const layout = findScreenLayout(screenId);

    const gridId = positionToGridId(position);
    layout.screenData.halfScreenRight =
      layout.screenData.halfScreenRight === gridId ? null : gridId;

    setScreenLayout(screenId, layout);
  };

  const setHalfScreen: ScreenMethods["setHalfScreen"] = (
    screenId,
    position,
  ) => {
    const layout = findScreenLayout(screenId);

    const gridId = positionToGridId(position);

    // Use the default strategy for half screen assignment
    const strategy = halfScreenStrategies.fillAvailableStrategy;
    const updatedLayout = strategy(layout, gridId, position);

    setScreenLayout(screenId, updatedLayout);
  };

  return {
    getOverlays,
    setFullScreen,
    setHalfScreenLeft,
    setHalfScreenRight,
    setHalfScreen,
  };
};
